import styled from 'styled-components';

export const FooterItem = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  font-weight: 600;
  line-height: 24px;
  text-decoration: none;
  font-size: 0.9rem;
  color: #ffffffb2;
  text-underline-offset: 2px;
  cursor: pointer;
  margin-left: 8px;
  user-select: none;

  & :last-child {
    margin-right: 0px;
  }
  &:hover,
  &:focus {
    color: #ffffffb2;
  }
  @media screen and (min-width: 992px) {
    margin-bottom: 0px;
    & :last-child {
      margin-right: 0px;
    }
  }
  @media (max-width: 480px) {
    font-size: 14px;
    font-weight: 400;
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  height: 100px;
  margin-left: 20px;
  margin-right: 20px;
  border-top: 1px solid rgba(151, 151, 151, 0.1);
`;

export const FooterTextBlock = styled.div`
  display: flex;
  gap: 20px;
`;

export const FooterSubBlock = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
  }
`;
export const Line = styled.hr`
  color: #ffffff;
  background-color: #ffffff;
  border: none;
  opacity: 0.1;
`;
